<div class="dropdown-container">
    <div class="aria-live-hidden" aria-live="polite">
        {{ languageChangeText }}
    </div>
    <div
        #languageBtn
        role="button"
        class="menu-wrapper"
        (keydown.enter)="menuOnClick()"
        (click)="menuOnClick()"
        tabindex="0"
        [attr.aria-label]="label"
    >
        <r-svg-icon class="r-lang-icon" [name]="languageIconKey"></r-svg-icon>
        <span class="text" *ngIf="label"> {{ label }} </span>
    </div>
    <div
        [ngClass]="{
            dropdown: true,
            top: dropdownPosition === 'top',
            bottom: dropdownPosition === 'bottom',
            'no-label': !label
        }"
        [class.active]="isActive"
    >
        <div role="dialog" [attr.aria-label]="dialogAriaLabel" class="wrapper">
            <div (focus)="onFocusFirstGuardian()" tabindex="0"></div>
            <ul>
                <li *ngFor="let item of languagesData; trackBy: trackByLanguageValue; index as langIndex">
                    <span
                        #languageElements
                        [attr.aria-pressed]="activeLanguage === item.value"
                        role="button"
                        [class.active]="activeLanguage === item.value"
                        (click)="onChange(item.value)"
                        (keydown.enter)="onChange(item.value)"
                        (keydown.escape)="closeAndFocusBack()"
                        tabindex="0"
                    >
                        {{ item.label }}
                    </span>
                </li>
            </ul>
            <div (focus)="onFocusLastGuardian()" tabindex="0"></div>
        </div>
    </div>
    <div class="dropdown-underlay" [class.active]="isActive" (click)="toggleMenu()"></div>
</div>
